var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499.1 451a18 18 0 0 0-7.7-12.1 18.4 18.4 0 0 0-28.2 19.6 4.1 4.1 0 0 1-1 3.5 3.4 3.4 0 0 1-2.8 1.3H40.5c-.5 0-1 0-1.6-.3-.5-.3-.9-.6-1.2-1a3.8 3.8 0 0 1-.8-3.5A218 218 0 0 1 110.5 337c37.4-31.2 84.3-49 133.1-50.7H255a219 219 0 0 1 176 96.1 18.4 18.4 0 0 0 30.6-20.3A254 254 0 0 0 328 262.6a143 143 0 0 0 59.2-160.4A143 143 0 0 0 249.6 0a144 144 0 0 0-137.7 102.2 142.2 142.2 0 0 0 59.2 160.4A256.8 256.8 0 0 0 1 451a40.5 40.5 0 0 0 39.6 49h419a40.5 40.5 0 0 0 39.6-49zM142.6 143.2a106 106 0 0 1 66-98.2 107.4 107.4 0 0 1 116.5 23 106.2 106.2 0 0 1-75.6 181.6c-28.3 0-55.5-11.3-75.5-31.2-20-20-31.3-47-31.4-75.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3d69ed76.svg";
export { ForwardRef as ReactComponent };